import { render, staticRenderFns } from "./FlowBookingRequest.vue?vue&type=template&id=4f2fed85&lang=pug&"
import script from "./FlowBookingRequest.vue?vue&type=script&lang=ts&"
export * from "./FlowBookingRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports